import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "./../index";
import { Button, Modal, Form, Input, Radio } from "antd";
import Idiachi from "./../../../assets/images/idiachi.svg";
import Ihoten from "./../../../assets/images/ihoten.svg";
import Imst from "./../../../assets/images/imst.svg";
import Idoanhnghiep from "./../../../assets/images/idoanhnghiep.svg";
import Close from "./../../../assets/images/dateclose.png";

const ModalVAT = (props) => {
  const [vat, setVAT] = useState(null);
  const [typeId, setTypeId] = useState(1);
  const [form] = Form.useForm();
  const formRef = React.createRef();

  useEffect(async () => {
    let dataVAT = JSON.parse(localStorage.getItem("vatBHN"));
    if (dataVAT) {
      setVAT(dataVAT);
      form.setFieldsValue(dataVAT);
    } else {
      form.resetFields();
      // form.setFieldsValue({typeId: 1,name:dataIsu?.buyerName,address: dataIsu?.address});
    }
  }, [props.isModalVisible]);

  const actionFormVAT = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        // console.log(values);
        let vat = {
          ...values,
          typeName: +values?.typeId === 1 ? 'Cá nhân' : 'Doanh nghiệp'
        }
        localStorage.setItem("vatBHN", JSON.stringify(vat));
        setVAT(vat);
        props.handleCancel();
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  const onFinishFailed = (errorInfo) => {
    const firstErrorField = errorInfo.errorFields[0];
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name[0]);
      form.getFieldInstance(firstErrorField.name[0])?.focus();
    }
  };

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "90%",
        }}
        centered={true}
        footer={false}
        closable={true}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{ background: "#000000", opacity: 0.8 }}
      >
        <Form scrollToFirstError onFinishFailed={onFinishFailed} ref={formRef} form={form} onFinish={actionFormVAT} name="VAT">
          <div>
            <div
              style={{
                borderBottom: "1px solid #dddddd",
                fontWeight: 500,
                fontSize: 16,
                padding: '0px 0px 10px 0px',
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                position: "sticky",
                top: 0,
                backgroundColor: "#FFF",
                borderRadius: "15px 15px 0px 0px",
              }}
            >
              <div style={{ width: "90%", textAlign: "center", fontSize: 18, fontWeight: 'bold', marginTop: -10 }}>
                Thông tin xuất hoá đơn
              </div>
              {/* <div>
                <img
                  onClick={() => props.handleCancel()}
                  src={Close}
                  alt="Global Care"
                  width={20}
                />
              </div> */}
            </div>
            <div style={{ padding: "10px 10px 0px 10px" }}>
              <div>
                Lựa chọn hoá đơn<span style={{ color: "red" }}>*</span>
              </div>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                name="typeId"
                style={css.FormItemsHolder}
              >
                <Radio.Group onChange={(e) => setTypeId(e.target.value)}>
                  <Radio value={1}>Cá nhân</Radio>
                  <Radio value={2}>Doanh nghiệp</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            <div
              style={{ padding: "4px 10px 0px 10px", position: "relative" }}
            >
              <div style={css.titleInput}>
                {typeId === 1 ? 'Họ và tên' : 'Tên doanh nghiệp'}
                <span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={typeId === 1 ? Ihoten : Idoanhnghiep} alt="quyen loi" />
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={{ ...css.input, textTransform: 'capitalize' }}
                  placeholder={typeId === 1 ? 'Nhập họ và tên' : 'Nhập tên công ty'}
                />
              </Form.Item>
            </div>
            <div style={{ padding: "10px 10px 0px 10px" }}>
              <div style={{ marginRight: 5 }}>
                <div style={{ padding: "0px", position: "relative" }}>
                  <div style={css.titleInput}>Mã số thuế<span style={{ color: "red" }}>*</span></div>
                  <img style={css.iconInput} src={Imst} alt="quyen loi" />
                  <Form.Item
                    name="taxCode"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn và nhập thông tin",
                      },
                      {
                        // required: true,
                        message: "Vui lòng nhập đúng định dạng mã số thuế!",
                        pattern: /^[\d\-\/.\s]{10,}$/
                      }
                    ]}
                    style={css.FormItemsHolder}
                  >
                    <Input
                      autoComplete="off"
                      type={"text"}
                      style={css.input}
                      placeholder="Nhập mã số thuế"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div
              style={{
                padding: "10px 10px 0px 10px",
                position: "relative",
                marginBottom: 20,
              }}
            >
              <div style={css.titleInput}>
                Địa chỉ<span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Idiachi} alt="cmnd" />
              <Form.Item
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={css.input}
                  placeholder="Nhập địa chỉ"
                />
              </Form.Item>
            </div>
            <div
              style={{
                borderRadius: "16px 16px 0px 0px",
                justifyContent: "center",
                padding: "15px 10px",
                boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.1)",
                width: "100%",
                background: "#ffffff",
              }}
            >
              <Button
                htmlType="submit"
                size="large"
                style={{
                  border: "1px solid #2A3790",
                  fontSize: 14,
                  background: "#2A3790",
                  color: "#ffffff",
                  width: "100%",
                  textAlign: "center",
                  borderRadius: 8,
                  fontWeight: 600,
                  height: 45,
                }}
              >
                Cập nhật
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

const css = {
  input: {
    color: "#3A3A3A",
    zIndex: 1,
    fontSize: 15,
    boxShadow: "none",
    padding: "10px 35px",
    borderRadius: 9,
    width: "100%",
  },
  titleInput: { color: "#646D69", marginBottom: 3 },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  iconInput: {
    width: 20,
    margin: "14px 10px",
    position: "absolute",
    zIndex: 2,
  },
};

export default ModalVAT;
